import type { RouteObject } from 'react-router-dom';

import { ForgotPasswordPage, ResetPasswordPage } from './index';

export const ResetPasswordRoutes: RouteObject[] = [
  {
    path: '/reset-password/request',
    Component: ForgotPasswordPage,
  },
  {
    path: '/reset-password',
    Component: ResetPasswordPage,
  },
];

export const RequestResetPasswordRoute: RouteObject = {
  path: '/reset-password/request',
  Component: ForgotPasswordPage,
};

export const ResetPasswordRoute: RouteObject = {
  path: '/reset-password',
  Component: ResetPasswordPage,
};
